import Phaser from 'phaser';
import { BootScene } from './Scenes/BootScene';
import { PreloadScene } from './Scenes/PreloadScene';
import { MainMenuScene } from './Scenes/MainMenuScene';
import { GameScene } from './Scenes/GameScene';
import { LevelEditorScene } from './Scenes/LevelEditorScene';

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  width: 1280,
  height: 720,
  parent: 'game-container',
  pixelArt: true,
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 980 },
      debug: false,
    },
  },
  scene: [BootScene, PreloadScene, MainMenuScene, GameScene, LevelEditorScene],
};

window.addEventListener('load', () => {
  new Phaser.Game(config);
});
